import type { Router } from 'vue-router'

import { useAnalytics } from '@/composables/useAnalytics'

export function setupAnalytics(router: Router) {
	router.afterEach((to) => {
		const { trackPageView } = useAnalytics()
		const title =
			(to.meta?.title as string) ?? to.name?.toString() ?? to.fullPath
		trackPageView(to.fullPath, title)
	})
}
